import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Engine } from './components/Engine';
import { Results } from './components/Results';
import { Process } from './components/Process';
import { Tools } from './components/Tools';
import { Pricing } from './components/Pricing';
import { Reviews } from './components/Reviews';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { ReviewFab } from './components/ReviewFab';
interface AppProps {
  showReviewButton?: boolean;
  showPricing?: boolean;
}
export function App({
  showReviewButton = true,
  showPricing = true
}: AppProps) {
  return <div className="min-h-screen w-full bg-ink font-sans text-cream" data-id="element-0" data-mp="2wk0a329kipw1">
      <Nav data-id="element-1" data-mp="2wip54z4dzc3c" />
      <main data-id="element-2" data-mp="2whxaprmizken">
        <Hero data-id="element-3" data-mp="28ufqch5lbolp" />
        <Engine data-id="element-4" data-mp="28u5vaf5our95" />
        <Results data-id="element-5" data-mp="28tmi1bqzgr1g" />
        <Process data-id="element-6" data-mp="28t4j27cxrypu" />
        <Tools data-id="element-7" data-mp="28skzynbjv4a8" />
        {showPricing && <Pricing data-id="element-8" data-mp="23vkvuhy9gblr" />}
        <Reviews data-id="element-9" data-mp="23w4g45bdvc2y" />
        <FinalCta data-id="element-10" data-mp="23ujjma5idj2g" />
      </main>
      <Footer data-id="element-11" data-mp="23t8gmcjw0fce" />
      {showReviewButton && <ReviewFab data-id="element-12" data-mp="3ikha0f5th31m" />}
    </div>;
}